import * as React from "react";
import { styled } from "@mui/material";
//region [[ Styles ]]

const LoadingSuspenseFallbackView = styled("div")({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "space-evenly",
  height: "85%",
});

const RetryButton = styled("button")({});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface LoadingSuspenseFallbackProps {
  icon?: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
const TIMEOUT = 3000;
//endregion [[ Functions ]]

//region [[ Texts ]]
const RETRY_LOADING_TEXT = "Reload";
//endregion [[ Texts]]
export const LoadingSuspenseFallback = ({
  ...props
}: LoadingSuspenseFallbackProps) => {
  const [showRetry, setShowRetry] = React.useState(false);

  React.useEffect(() => {
    const retry = setTimeout(() => setShowRetry(true), TIMEOUT);
    return () => {
      clearTimeout(retry);
    };
  }, [setShowRetry]);

  return (
    <LoadingSuspenseFallbackView>
      Loading...
      {showRetry && (
        <>
          {props.icon}
          <RetryButton onClick={() => window?.location?.reload()}>
            {RETRY_LOADING_TEXT}
          </RetryButton>
        </>
      )}
    </LoadingSuspenseFallbackView>
  );
};
